import React from "react";
import { PROFILE, RELATIVES } from "../../mock";
import { MapPin, Calendar, User, Users, Heart } from "lucide-react";

function SectionTitle({ kicker, title, subtitle }) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-3 mb-4">
        <span className="h-px w-10 bg-gold" />
        <span className="text-xs tracking-[0.3em] uppercase text-gold font-medium">{kicker}</span>
      </div>
      <h2 className="font-display text-4xl md:text-5xl text-emerald-deep leading-tight">{title}</h2>
      {subtitle && <p className="mt-4 text-stone-600 text-lg">{subtitle}</p>}
    </div>
  );
}
export { SectionTitle };

export default function About() {
  const facts = [
    { icon: Calendar, label: "Born", value: PROFILE.birth },
    { icon: MapPin, label: "Lives in", value: "Thiruvananthapuram, Kerala" },
    { icon: User, label: "Spouse", value: PROFILE.spouse },
    { icon: Users, label: "Son", value: PROFILE.children }
  ];
  return (
    <section id="about" className="scroll-smooth-section py-24 bg-cream/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="The Man"
          title="A son of Mayyanad, a healer of minds and body"
          subtitle="From the legendary village of Mayyanad in Kollam — birthplace of journalists, reformers and educators — emerged a doctor whose life has been an unbroken thread of medicine, literature and quiet philanthropy."
        />

        <div className="mt-14 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-5 text-stone-700 leading-relaxed text-[17px]">
            <p><span className="font-display text-2xl text-emerald-deep float-left mr-2 leading-none">D</span>r. Shaji Prabhakaran was born in <em>Veliyil Kizhakkathil</em>, a well-educated traditional Ezhava family of Mayyanad — a village just 10 km from Kollam that has, for centuries, told a legendary story in the cultural, educational, social and political life of Kerala.</p>
            <p>Mayyanad is the motherland of world-famous journalists like <strong>C.V. Kunjuraman, K. Balakrishnan and K. Sukumaran</strong>. Dr. Shaji is, undoubtedly, an asset to that legacy — born into an extended family of scholars, physicians and public-minded administrators (see notable relatives, alongside).</p>
            <p>With self-consciousness and self-confidence he has built today's stature — a well-known neurologist, a generous teacher, a prolific author and an ardent believer in <strong>Sree Narayana Guru's</strong> teachings, adopting the Geetha ideology in his practical life.</p>
            <p>For three decades he served the Government Medical Colleges at Thiruvananthapuram, Alappuzha and Kottayam as Lecturer, Professor and Principal — retiring as Principal of Alappuzha Medical College.</p>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-ivory rounded-2xl p-6 shadow-sm border border-stone-200/60">
              <h3 className="font-display text-xl text-emerald-deep mb-4">At a glance</h3>
              <ul className="space-y-4">
                {facts.map((f, i) => (
                  <li key={i} className="flex gap-3">
                    <div className="w-10 h-10 rounded-full bg-emerald-soft flex items-center justify-center flex-shrink-0">
                      <f.icon className="w-5 h-5 text-emerald-deep" />
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-widest text-stone-500">{f.label}</div>
                      <div className="text-stone-800">{f.value}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-6 bg-emerald-deep rounded-2xl p-6 text-ivory">
              <div className="flex items-center gap-2 text-gold">
                <Heart className="w-4 h-4" />
                <span className="text-xs uppercase tracking-widest">Notable relatives</span>
              </div>
              <ul className="mt-4 space-y-2 text-ivory/90 text-sm">
                {RELATIVES.map((r, i) => <li key={i} className="flex gap-2"><span className="text-gold">❧</span> {r}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
